export default __webpack_public_path__ + "static/media/m_prase_divoke-min.1761f95f.jpg";